import { render, staticRenderFns } from "./IzinProyekViewNew.vue?vue&type=template&id=43a2f290&scoped=true&lang=pug&"
import script from "./IzinProyekViewNew.vue?vue&type=script&lang=js&"
export * from "./IzinProyekViewNew.vue?vue&type=script&lang=js&"
import style0 from "./IzinProyekViewNew.vue?vue&type=style&index=0&id=43a2f290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2f290",
  null
  
)

export default component.exports